export default {
  getters: {
    whoWeAre(state) {
      return state.whoWeAre;
    },
  },
};
